module.exports = __webpack_public_path__ + "static/media/acado-logo.b2beae2d.png";